module.exports = "/content/997df974f091d07b10ff03b27834f141.png";